import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/products/sus1.jpg")